module.exports = __webpack_public_path__ + "img/shine-violet.2e8dc85b.png";